import React, { useEffect } from 'react';

interface BreadcrumbSegment {
    label: string;
    onClick: () => void;
}

interface SlideInPanelProps {
    isOpen: boolean;
    onClose: () => void;
    width?: string;
    breadcrumbs: BreadcrumbSegment[];
    children: React.ReactNode;
    title?: string;
    level?: number;
}

const SlideInPanel: React.FC<SlideInPanelProps> = ({
    isOpen,
    onClose,
    width = '50%',
    breadcrumbs,
    children,
    title,
    level = 1,
}) => {

    const overlayClass = `operations-slide-overlay ${isOpen ? 'open' : ''}${level > 1 ? ' level-2' : ''}`;
    const panelClass = `operations-slide-panel ${isOpen ? 'open' : ''}${level > 1 ? ' level-2' : ''}`;

    return (
        <>
            <div className={overlayClass} onClick={onClose} />
            <div className={panelClass} style={{ width }}>
                <div className="operations-slide-header">
                    <div className="operations-breadcrumbs">
                        {breadcrumbs.map((segment, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <span className="operations-breadcrumb-sep">›</span>}
                                <span
                                    className={`operations-breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
                                    onClick={index < breadcrumbs.length - 1 ? segment.onClick : undefined}
                                >
                                    {segment.label}
                                </span>
                            </React.Fragment>
                        ))}
                    </div>
                    <button
                        type="button"
                        className="operations-slide-close"
                        onClick={onClose}
                        aria-label="Закрыть"
                    >
                        ✕
                    </button>
                </div>
                {title && (
                    <div className="operations-slide-title-row">
                        <h2 className="operations-slide-title">{title}</h2>
                    </div>
                )}
                <div className="operations-slide-body">
                    {children}
                </div>
            </div>
        </>
    );
};

export default SlideInPanel;
